import { Heading } from '@chakra-ui/react'

import { useInterview } from '@/react-query/interview/interview'
import { useUser } from '@/react-query/user'
import Card from '@/views/components/Card'

import { ErrorState } from './components/ErrorState'
import { InterviewersList } from './components/InterviewersList'
import { LoadingState } from './components/LoadingState'
import { AddInterviewerMenu } from './AddInterviewerMenu'

export const InterviewerCard = () => {
  const {
    data: interview,
    isLoading: isLoadingInterview,
    error: interviewError,
  } = useInterview()
  const { data: user, isLoading: isLoadingUser } = useUser()

  // Don't render if user doesn't have team member access
  if (!isLoadingUser && !user?.TeamMember) {
    return null
  }

  return (
    <Card className="flex flex-col min-h-[10rem] px-[2.5rem] py-[1.8rem] w-full mb-10">
      <Heading size={'sm'}>Interviewers</Heading>

      {/* Error state */}
      {interviewError && <ErrorState />}

      {/* Loading state */}
      {isLoadingInterview && !interviewError && <LoadingState />}

      {/* Content */}
      {!isLoadingInterview && !interviewError && (
        <>
          <InterviewersList interviewers={interview?.interviewers || []} />
          <AddInterviewerMenu />
        </>
      )}
    </Card>
  )
}
